export const noAssignedBoardName = 'No task group assigned';
export const archivedBoardName = 'Previous version tasks';
